import { render } from "./Faq.vue?vue&type=template&id=6e596c0e&scoped=true"
import script from "../js/faq.js?vue&type=script&lang=js"
export * from "../js/faq.js?vue&type=script&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=6e596c0e&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e596c0e"]])

export default __exports__